module.exports = __webpack_public_path__ + "img/gift_box99.e3e69e89.png";